export default __webpack_public_path__ + "static/media/sites-mob14.896e9e6b.png";